import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  constructor() { }


  removeDashFromCreditCard(value: string): string {
    if (value.includes('-')) {
      const splitted = value.split(' - ');
      return splitted.join('');
    } else {
      return value;
    }
  }


  /**
   * rmeoves separator commas within a string
   * @param s [string]
   */
  removeCommasFromNumber(s: string): number {
    if (s.length > 3 && s.includes(',')) {
      return parseInt(s.split(',').join(''), 10);
    } else { return parseInt(s, 10) }
  }

  /**
   * calculate client device width
   */
  isMobileDevice(): boolean {
    return screen.width < 992;
  }

}
